module.exports = __webpack_public_path__ + "static/img/icon-logo-white.63b2d9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-logo-white.svg
// module id = V/7x
// module chunks = 10